import { FilterX, Search } from 'lucide-react'
import { MultiSelector } from '@/components/shared/MultiSelector'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import type { UserRole } from '@/types'

interface UsersToolbarProps {
  search: string
  onSearchChange: (value: string) => void
  selectedRoles: UserRole[]
  onSelectedRolesChange: (value: UserRole[]) => void
  onClearFilters: () => void
  hasActiveFilters: boolean
}

const USER_ROLE_OPTIONS: Array<{ id: UserRole; label: string }> = [
  { id: 'admin', label: 'Administrador' },
  { id: 'operator', label: 'Operador' },
  { id: 'client', label: 'Cliente' },
]

export function UsersToolbar({
  search,
  onSearchChange,
  selectedRoles,
  onSelectedRolesChange,
  onClearFilters,
  hasActiveFilters,
}: UsersToolbarProps) {
  return (
    <div className="flex flex-col items-start gap-3 xl:flex-row xl:flex-wrap xl:items-center">
      <div className="relative w-full xl:w-auto xl:min-w-[20rem] xl:max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar usuarios..."
          className="h-10 border-border bg-background pl-9"
          aria-label="Buscar usuarios"
        />
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <MultiSelector
          title="Tipo"
          options={USER_ROLE_OPTIONS}
          selected={selectedRoles}
          setFilterValue={(values) => onSelectedRolesChange(values as UserRole[])}
        />

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onClearFilters}
          disabled={!hasActiveFilters}
          className="h-10 w-10 shrink-0 border-border bg-background p-0 hover:bg-accent"
          aria-label="Limpiar filtros"
          title="Limpiar filtros"
        >
          <FilterX className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
